export const indianIndustries = [
    "Agriculture", "Automotive", "Banking & Finance", "Biotechnology", "Capital Goods",
    "Chemicals", "Construction", "Defence Manufacturing", "Education", "Electronics System Design & Manufacturing",
    "Engineering", "FMCG (Fast Moving Consumer Goods)", "Gems and Jewellery", "Healthcare",
    "Infrastructure", "IT & BPM (Business Process Management)", "Leather & Leather Products",
    "Logistics", "Manufacturing", "Media and Entertainment", "Medical Devices", "Metals and Mining",
    "Oil and Gas", "Pharmaceuticals", "Ports and Shipping", "Power & Energy", "Railways",
    "Real Estate", "Renewable Energy", "Retail", "Roads and Highways", "Science and Technology",
    "Services", "Space", "Telecommunications", "Textiles and Apparel", "Tourism and Hospitality"
].sort();
